import { ethers } from 'ethers';

/**
 * BrowserProviderを初期化
 * @returns {Promise<ethers.BrowserProvider|null>}
 */
export async function initBrowserProvider() {
  if (!window.ethereum) {
    return null;
  }
  return new ethers.BrowserProvider(window.ethereum);
}

/**
 * コントラクトインスタンスを作成
 * @param {string} address - コントラクトアドレス
 * @param {Array} abi - コントラクトABI
 * @param {ethers.BrowserProvider} provider - プロバイダー
 * @returns {Promise<ethers.Contract>}
 */
export async function createContract(address, abi, provider) {
  const signer = await provider.getSigner();
  return new ethers.Contract(address, abi, signer);
}

/**
 * ネットワークIDを取得
 * @param {ethers.BrowserProvider} provider - プロバイダー
 * @returns {Promise<number>}
 */
export async function getNetworkId(provider) {
  const network = await provider.getNetwork();
  return Number(network.chainId);
}

/**
 * アカウントアドレスを取得
 * @param {ethers.BrowserProvider} provider - プロバイダー
 * @returns {Promise<string|null>}
 */
export async function getAccountAddress(provider) {
  const accounts = await provider.listAccounts();
  return accounts.length > 0 ? accounts[0].address : null;
}

/**
 * 複数のアカウントアドレスを取得
 * @param {ethers.BrowserProvider} provider - プロバイダー
 * @returns {Promise<string[]>}
 */
export async function getAccountAddresses(provider) {
  const accounts = await provider.listAccounts();
  return accounts.map(account => account.address);
}

